import { CSSProperties, forwardRef, ReactElement, Ref } from 'react';
import { theme } from 'antd';
import { BoxProps } from './types';

const { useToken } = theme;

/**
 * 页面直接使用div，无法跟随主题的风格切换颜色，设置Box组件
 * @param props
 * @returns
 */
function BoxComponent(props: BoxProps, ref: Ref<HTMLDivElement>): ReactElement {
  const { component = 'div' } = props;
  const { token } = useToken();

  const overrideStyle: CSSProperties = {
    ...props.style,
    backgroundColor: token.colorBgContainer,
    color: token.colorText
  };

  if (component === 'div') {
    return <div ref={ref} {...props} style={overrideStyle} />;
  }

  return <span ref={ref} {...props} style={overrideStyle} />;
}

export const Box = forwardRef<HTMLDivElement, BoxProps>(BoxComponent);
